import http from "../utils/http";

export default {

  async createRequest(data) {
    return http({
      url: `api/demo-request`,
      method: "post",
      data
    });
  },
  
};
